import { Observable } from 'rxjs';

export enum ToastSeverity {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Danger = 'danger',
}

export enum ToastActionKind {
  Undo = 'undo',
  View = 'view',
}

export interface ToastAction {
  kind: ToastActionKind;
  label: string;
  run: () => void;
}

export interface ToastConfig {
  severity: ToastSeverity;
  title: string;
  message?: string;
  durationMs?: number | null;
  action?: ToastAction;
  pauseOnHover?: boolean;
}

export interface ToastRef {
  readonly afterClosed: Observable<void>;
  close(): void;
}
